import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

const Container = styled.div`
  width: 100%;
`;

const Paragraph = styled.p`
  margin: 0;
  float: left;
  width: 100%;
`;

const RemoveLink = styled.a`
  float: right;
`;

export default function ProfileComment({ comment }) {
  return (
    <article className="comment position-relative profile_comment clear">
      <Container className="float-left margin-lrg-btm">
        <p
          className="margin-sml-btm"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: comment.body }}
        />
        <Paragraph>
          <span>
            {'On '}
          </span>
          <a href={`/wires/${comment.wire.slug}`}>{comment.wire.title}</a>
          <span>{` - ${moment(comment.publishedAt).fromNow()}`}</span>
          {comment.userId === window.Livewire.currentUser.id && (
            <RemoveLink
              href={`/wires/${comment.wire.slug}/comments/${comment.id}`}
              data-method="delete"
            >
              Remove comment
            </RemoveLink>
          )}
        </Paragraph>
      </Container>
    </article>
  );
}

ProfileComment.propTypes = {
  comment: PropTypes.shape({
    body: PropTypes.string.isRequired,
    publishedAt: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    wire: PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    }).isRequired,
    userId: PropTypes.number.isRequired,
  }).isRequired,
};
